import React from 'react';
import { TAIndicatorDef } from '../../types';
import { ReactComponent as AddCircleIcon } from '../../../../assets/icons/StockChart/add-circle-line.svg';
import '../../../../Components/Common/typography.css';
import './TechnicalAnalysisSettings.css';

interface AvailableIndicatorsListProps {
  filteredCatalogue: Record<string, TAIndicatorDef[]>;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAdd: (indicator: TAIndicatorDef, category: string) => void;
  atMax: boolean;
}

const AvailableIndicatorsList: React.FC<AvailableIndicatorsListProps> = ({
  filteredCatalogue,
  searchQuery,
  onSearchChange,
  onAdd,
  atMax,
}) => {
  return (
    <div className="ta-available-section">
      <div className="ta-available-header">
        <span className="body-s-regular">Available Technical Analysis</span>
        <input
          type="text"
          className="ta-search-input"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Indicator List by Category */}
      <div className="ta-category-list">
        {Object.entries(filteredCatalogue).map(([category, items]) => (
          <div key={category} className="ta-category-group">
            <div className="ta-category-title body-s-regular">{category}</div>
            <div className="ta-category-items">
              {items.map((indicator) => {
                const isDisabled = atMax;
                return (
                  <div
                    key={indicator.key}
                    className={`ta-available-item${isDisabled ? ' ta-available-item-disabled' : ''}`}
                    onClick={() => !isDisabled && onAdd(indicator, category)}
                  >
                    <span
                      className="ta-add-icon"
                      aria-label={`Add ${indicator.label}`}
                    >
                      <AddCircleIcon />
                    </span>
                    <span className="body-m-regular">{indicator.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        {Object.keys(filteredCatalogue).length === 0 && (
          <div className="ta-no-results body-m-regular">
            No indicators found
          </div>
        )}
      </div>
    </div>
  );
};

export default AvailableIndicatorsList;
